export default "https://d1e6s5z4lzmgxx.cloudfront.net/9448f7a6-2ffc-48da-926d-72a27a448f00/images/sidebar-logo.png?69c8ab64fd1cfda09f22fc646c162ca4";